var ninja_config = {
  apiKey: "AIzaSyAnDDCCofYV9YFMBpJD8YiAAZHOgSPWIRo",
  authDomain: "ninjasellers.com",
  databaseURL: "https://shark-sellers-default-rtdb.firebaseio.com",
  projectId: "shark-sellers",
  storageBucket: "shark-sellers.appspot.com",
  messagingSenderId: "401296661434",
  appId: "1:401296661434:web:928513667886694f7b9b83",
  measurementId: "G-GQCYYTDQNP"
};

var ashyaat_config = {
  apiKey: "AIzaSyBXrPDctifiX_pg3ElmuNfklbnPQv-ggK8",
  authDomain: "ashyaatcrm.firebaseapp.com",
  databaseURL: "https://ashyaatcrm.firebaseio.com",
  projectId: "ashyaatcrm",
  storageBucket: "ashyaatcrm.appspot.com",
  messagingSenderId: "697070147563",
  appId: "1:697070147563:web:55a5b1cd4ff0a849"
};

module.exports = {
  ninja_config,
  ashyaat_config
}